module.exports = __webpack_public_path__ + "static/img/202407.541d318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/202407.png
// module id = NPi6
// module chunks = 0